<div class="popup-backdrop">
    <section class="popup-dialog" role="dialog" aria-modal="true" aria-labelledby="construct-x-popup-title"
        aria-describedby="construct-x-popup-message">
        <header class="popup-header">
            <span>Construct-X</span>
            <h2 id="construct-x-popup-title">{{ popUpObj.title | translate }}</h2>
        </header>

        <div class="popup-body">
            <p id="construct-x-popup-message">{{ popUpObj.message | translate }}</p>
        </div>

        <footer class="popup-actions">
            @for (action of popUpObj.actions; track action.text; let last = $last) {
            @if (last) {
            <button mat-flat-button color="primary" type="button" (click)="runAction(action.action)">
                {{ action.text | translate }}
            </button>
            } @else {
            <button mat-stroked-button color="primary" type="button" (click)="runAction(action.action)">
                {{ action.text | translate }}
            </button>
            }
            }
        </footer>
    </section>
</div>
